import { DateTime } from '@skyjs/date';
import redirectToLogin from './redirectToLogin.js';
import getTokenExpirationDate from './getTokenExpirationDate.js';
import refreshAuthToken from './refreshAuthToken.js';

let authTokenRefreshTimeout;

export default function autoRefreshAuthToken(
  authToken,
  authTokenExpirationDate,
  refreshToken,
  onAuthTokenUpdated
) {
  clearTimeout(authTokenRefreshTimeout);

  let tokenExpiration;

  if (authToken != null) {
    if (refreshToken == null) return;
    tokenExpiration = getTokenExpirationDate(authToken);
    if (tokenExpiration == null) return;
  } else if (authTokenExpirationDate != null) {
    tokenExpiration = DateTime.fromISO(authTokenExpirationDate);
  } else {
    return;
  }

  const diff = tokenExpiration.diff(DateTime.now, 'second');
  const timeout = diff <= 30 ? diff : diff - 30;

  authTokenRefreshTimeout = setTimeout(async () => {
    try {
      const {
        authToken: newAuthToken,
        authTokenExpirationDate: newAuthTokenExpirationDate,
        refreshToken: newRefreshToken
      } = await refreshAuthToken();

      onAuthTokenUpdated(newAuthToken, newAuthTokenExpirationDate, newRefreshToken);
    } catch (err) {
      if (err.status === 401) {
        await redirectToLogin();
      } else {
        throw err;
      }
    }
  }, timeout * 1000);
}
